export class FeedbackToSlackNotFoundError extends Error { }
